import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dayToMonth, getWeekDay } from '../../pages/BookingSystemPage/utils';
import { fetchSpecialistCalendar } from 'src/api/specialist/calendar';

export const getPsychologistCalender = createAsyncThunk(
  'calendarData/getPsychologistCalender',
  async (psychologistId: string) => {
    try {
      const result = await fetchSpecialistCalendar(psychologistId);

      return { scheduleWithTimezone: result };
    } catch (error) {
      return error;
    }
  }
);

export interface InitialState {
  fromDataDay: string;
  date: number;
  day: string;
  month: string;
  timeArray: string[];
}

const initialState: InitialState[] = [];

const slice = createSlice({
  name: 'calendarData',
  initialState,
  reducers: {
    cleanCalendar: () => {
      return [];
    },
  },
  extraReducers: {
    [getPsychologistCalender.fulfilled.type]: (state, action) => {
      try {
        if (!action.payload) return;

        const { scheduleWithTimezone } = action.payload;
        const response = [];

        for (let day in scheduleWithTimezone) {
          const LocalDayDate = new Date(day);
          LocalDayDate.setMinutes(LocalDayDate.getMinutes() + LocalDayDate.getTimezoneOffset());
          response.push({
            fromDataDay: day,
            date: LocalDayDate.getDate(),
            day: getWeekDay(LocalDayDate.getDay()),
            month: dayToMonth(LocalDayDate.getMonth()),
            timeArray: scheduleWithTimezone[day].map((el: string | number | Date) => {
              const LocalFreeHourDate = new Date(el).toLocaleTimeString('uk-UK').split(':');
              LocalFreeHourDate.pop();
              return LocalFreeHourDate.join(':');
            }),
          });
        }
        return response;
      } catch (e) {
        return [];
      }
    },
    [getPsychologistCalender.rejected.type]: () => {
      console.error('getPsychologistCalender reducer was broken');
    },
  },
});

export default slice.reducer;
export const { cleanCalendar } = slice.actions;
